import cx from "classnames";
import React from "react";

import { dummyPhoto } from "@/mk2/apps/strollers/constants";
import { StrollerEntity } from "@/mk2/apps/strollers/schemas";
import { strollersDetailUrl } from "@/mk2/apps/strollers/urls";
import { Dot } from "@/mk2/components/Dot";
import { ImgCropMode, ImgCropped } from "@/mk2/components/ImgCropped";
import { Interpolate } from "@/mk2/components/Interpolate";
import { Link } from "@/mk2/components/Link";
import { StarsRating } from "@/mk2/components/StarsRating";
import { url } from "@/mk2/helpers/urls";
import { STROLLER_REVIEWS, counter_RATINGS } from "@/mk/autogenerated/translation";

import styles from "./StrollerReviewsHeader.mscss";

interface OwnProps {
    className?: string;
    stroller: StrollerEntity;
    showScore: boolean;
}

export class StrollerReviewsHeader extends React.Component<OwnProps> {
    public render() {
        const { stroller, className } = this.props;
        const strollerPhoto = stroller.previewPhoto || dummyPhoto;

        return (
            <Link
                to={url(strollersDetailUrl, { slug: stroller.slug })}
                className={cx(styles.StrollerReviewsHeader, className)}
            >
                <h1 className={styles.StrollerReviewsHeader__title}>
                    {STROLLER_REVIEWS} {stroller.name}
                </h1>
                <div className={styles.StrollerReviewsHeader__container}>
                    <div className={styles.StrollerReviewsHeader__image}>
                        <ImgCropped
                            width={80}
                            height={80}
                            mode={ImgCropMode.Embed}
                            imgWidth={strollerPhoto.originalWidth}
                            imgHeight={strollerPhoto.originalHeight}
                            imgUrl={strollerPhoto.url250x250}
                            lazy={false}
                        />
                    </div>
                    <div className={styles.StrollerReviewsHeader__reviews}>
                        {stroller.userScore > 0 && (
                            <>
                                <StarsRating
                                    className={styles.StrollerReviewsHeader__reviews__score}
                                    starsCount={stroller.userScore}
                                    canShowHalf
                                />
                                <Dot spaces={1} />
                            </>
                        )}
                        <Interpolate
                            className={styles.StrollerReviewsHeader__reviews__count}
                            i18nKey={counter_RATINGS}
                            counter={stroller.reviewsCount}
                            count={stroller.reviewsCount}
                        />
                    </div>
                </div>
            </Link>
        );
    }
}
